import ViewBADetailsLayout from '@/core/layout/viewba-details/viewba-details.layout'

const ViewBADetailsPage = () => {
    return <ViewBADetailsLayout />
}

export default ViewBADetailsPage

